import { Color } from '@billy/design-system'
import styled from '@emotion/styled'

import { getTableCellStyles } from '../../utils/getTableCellStyles'

interface TableCellProps {
  shouldHaveBorder?: boolean
  nested?: boolean
}

export const TableCell = styled.td<TableCellProps>`
  ${getTableCellStyles()};

  ${({ nested }) =>
    nested &&
    `
      min-width: 120px;
    `}

  ${({ shouldHaveBorder }) =>
    shouldHaveBorder &&
    `
    position: relative;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 1px;
        height: 100%;
        background-color: ${Color.Grey150};
      }
  `}
`
